var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isRR && _vm.destinacaoUsoImovel.destinacaoImovelChecked
        ? _c("app-display", {
            class:
              _vm.compararDestinacaoUsoImovel &&
              _vm.compararDestinacaoUsoImovel.mudouDestinacaoImovelCheckeds
                ? "text"
                : "",
            attrs: {
              label: _vm.labelDestinacaoUsoImovel.destinacaoUsoImovel,
              content: _vm.destinacaoUsoImovel.destinacaoImovelChecked
            }
          })
        : _vm._e(),
      this.finalidades
        ? _c("app-display", {
            class:
              _vm.compararDestinacaoUsoImovel &&
              _vm.compararDestinacaoUsoImovel.mudouDestinacaoImovel
                ? "text"
                : "",
            attrs: {
              label: _vm.labelDestinacaoUsoImovel.destinacaoUsoImovel,
              content: this.finalidades
            }
          })
        : _vm._e(),
      !this.isRR
        ? _c("app-display", {
            class:
              _vm.compararDestinacaoUsoImovel &&
              _vm.compararDestinacaoUsoImovel.mudouPossuiReservaLegal
                ? "text"
                : "",
            attrs: {
              label: "Possui Reserva Legal?",
              content: _vm.formatPossuiReservaLegal(
                _vm.destinacaoUsoImovel.possuiReservaLegal
              )
            }
          })
        : _vm._e(),
      _vm.hasReservaLegal()
        ? _c("app-display", {
            class:
              _vm.compararDestinacaoUsoImovel &&
              _vm.compararDestinacaoUsoImovel.mudouAreaReservaLegal
                ? "text"
                : "",
            attrs: {
              label: "Área:",
              content:
                _vm.destinacaoUsoImovel.areaReservaLegal &&
                _vm.destinacaoUsoImovel.areaReservaLegal != 0
                  ? _vm.formatterDecimal(
                      _vm.destinacaoUsoImovel.areaReservaLegal,
                      4
                    ) + " hectare(s)"
                  : "Não informado"
            }
          })
        : _vm._e(),
      _vm.hasReservaLegal()
        ? _c("app-display", {
            class:
              _vm.compararDestinacaoUsoImovel &&
              _vm.compararDestinacaoUsoImovel.mudouPercentualAreaReservaLegal
                ? "text"
                : "",
            attrs: {
              label: "Percentual utilizado:",
              content:
                _vm.destinacaoUsoImovel.percentualAreaReservalegal &&
                _vm.destinacaoUsoImovel.percentualAreaReservalegal != 0
                  ? _vm.formatPercentualAreaReservaLegal(
                      _vm.destinacaoUsoImovel.percentualAreaReservalegal
                    )
                  : "Não informado"
            }
          })
        : _vm._e(),
      _vm.destinacaoUsoImovel.totalAreaEmUso
        ? _c("app-display", {
            class:
              _vm.compararDestinacaoUsoImovel &&
              _vm.compararDestinacaoUsoImovel.mudouTotalAreaEmUso
                ? "text"
                : "",
            attrs: {
              label: "Total da área em uso:",
              content: _vm.destinacaoUsoImovel.totalAreaEmUso
            }
          })
        : _vm._e(),
      _vm.destinacaoUsoImovel.tipoReservaLegal
        ? _c("app-display", {
            attrs: {
              label: "Tipo de reserva:",
              content: _vm.formatTipoReservaLegal(
                _vm.destinacaoUsoImovel.tipoReservaLegal
              )
            }
          })
        : _vm._e(),
      _vm.isOnerosoGroup &&
      _vm.destinacaoUsoImovel.produtividade != null &&
      _vm.destinacaoUsoImovel.produtividade.tipo != null &&
      _vm.destinacaoUsoImovel.produtividade.tipo !== ""
        ? _c("app-divider", { attrs: { label: "Informações de Produção " } })
        : _vm._e(),
      _vm.isOnerosoGroup &&
      _vm.destinacaoUsoImovel.produtividade != null &&
      _vm.destinacaoUsoImovel.produtividade.tipo != null &&
      _vm.destinacaoUsoImovel.produtividade.tipo !== ""
        ? _c(
            "el-row",
            { staticClass: "margin-top" },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.destinacaoUsoImovel.produtividade.possuiComprovante !=
                    null &&
                  _vm.destinacaoUsoImovel.produtividade.possuiComprovante != ""
                    ? _c("app-display", {
                        attrs: {
                          label: "Possui comprovante de produtividade?",
                          content: _vm.destinacaoUsoImovel.produtividade
                            .possuiComprovante
                            ? "Sim"
                            : "Não"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm.destinacaoUsoImovel.produtividade.possuiComprovante ||
              _vm.destinacaoUsoImovel.produtividade.tipo != ""
                ? _c(
                    "div",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.destinacaoUsoImovel.produtividade.tipo != null
                            ? _c("app-display", {
                                class:
                                  _vm.compararDestinacaoUsoImovel &&
                                  _vm.compararDestinacaoUsoImovel
                                    .mudouProdutividade &&
                                  _vm.compararDestinacaoUsoImovel
                                    .mudouProdutividade.mudouTipo
                                    ? "text"
                                    : "",
                                attrs: {
                                  label: "Tipo de comprovante:",
                                  content: _vm.formatTipoComprovante(
                                    _vm.destinacaoUsoImovel.produtividade.tipo
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.destinacaoUsoImovel.produtividade.dap &&
                          _vm.destinacaoUsoImovel.produtividade.tipo == "DAP"
                            ? _c("app-display", {
                                class:
                                  _vm.compararDestinacaoUsoImovel &&
                                  _vm.compararDestinacaoUsoImovel
                                    .mudouProdutividade &&
                                  _vm.compararDestinacaoUsoImovel
                                    .mudouProdutividade.mudouNumeroDAP
                                    ? "text"
                                    : "",
                                attrs: {
                                  label: "Número do DAP:",
                                  content:
                                    _vm.destinacaoUsoImovel.produtividade.dap
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.destinacaoUsoImovel.produtividade.drp &&
                          _vm.destinacaoUsoImovel.produtividade.tipo == "DRP"
                            ? _c("app-display", {
                                class:
                                  _vm.compararDestinacaoUsoImovel &&
                                  _vm.compararDestinacaoUsoImovel
                                    .mudouProdutividade &&
                                  _vm.compararDestinacaoUsoImovel
                                    .mudouProdutividade.mudouNumeroDRP
                                    ? "text"
                                    : "",
                                attrs: {
                                  label: "Número do DRP:",
                                  content:
                                    _vm.destinacaoUsoImovel.produtividade.drp
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _vm.destinacaoUsoImovel.produtividade.documentos &&
                          _vm.destinacaoUsoImovel.produtividade.documentos
                            .length > 0
                            ? _c("listagem-documentos", {
                                attrs: {
                                  documentos:
                                    _vm.destinacaoUsoImovel.produtividade
                                      .documentos,
                                  protocoloCadastroOriginal:
                                    _vm.protocoloCadastroOriginal,
                                  ownerDocumento:
                                    "DESTINACAO_USO_IMOVEL_PRODUTIVIDADE",
                                  compararDocumentos:
                                    _vm.compararDestinacaoUsoImovel &&
                                    _vm.compararDestinacaoUsoImovel
                                      .mudouProdutividade &&
                                    _vm.compararDestinacaoUsoImovel
                                      .mudouProdutividade
                                      .mudouDocumentosDestinacaoUsoImovel
                                      ? "text"
                                      : "",
                                  versaoCadastro: _vm.versaoCadastro
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.showListagem
        ? _c("app-divider", { attrs: { label: "Atividades" } })
        : _vm._e(),
      _vm.destinacaoUsoImovel.culturasPermanentes &&
      _vm.destinacaoUsoImovel.culturasPermanentes.length > 0
        ? _c(
            "app-collapse-child",
            {
              class:
                _vm.compararDestinacaoUsoImovel &&
                _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                  ? "text-collapse"
                  : "",
              attrs: {
                title: "Culturas permanentes",
                name: "culturasPermanentes"
              }
            },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.destinacaoUsoImovel.culturasPermanentes }
                },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma cultura permanente cadastrada.")
                  ]),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                        .mudouTipo
                        ? "text"
                        : "",
                    attrs: {
                      prop: "descTipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                        .mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      prop: "area",
                      label: "Área",
                      formatter: _vm.formatAreaHectare
                    }
                  }),
                  _vm.produtividade
                    ? _c("el-table-column", {
                        class:
                          _vm.compararDestinacaoUsoImovel &&
                          _vm.compararDestinacaoUsoImovel
                            .mudouCulturaPermanente &&
                          _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                            .mudouProdutividade
                            ? "text"
                            : "",
                        attrs: {
                          prop: "produtividade",
                          label: "Produtividade",
                          width: "180",
                          formatter: _vm.formatProdutividade
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.destinacaoUsoImovel.culturasTemporarias &&
      _vm.destinacaoUsoImovel.culturasTemporarias.length > 0
        ? _c(
            "app-collapse-child",
            {
              class:
                _vm.compararDestinacaoUsoImovel &&
                _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                  ? "text-collapse"
                  : "",
              attrs: {
                title: "Culturas temporárias",
                name: "culturasTemporarias"
              }
            },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.destinacaoUsoImovel.culturasTemporarias }
                },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma cultura temporária cadastrada.")
                  ]),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                        .mudouTipo
                        ? "text"
                        : "",
                    attrs: {
                      prop: "tipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                        .mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      prop: "area",
                      label: "Área",
                      formatter: _vm.formatAreaHectare
                    }
                  }),
                  _vm.produtividade
                    ? _c("el-table-column", {
                        class:
                          _vm.compararDestinacaoUsoImovel &&
                          _vm.compararDestinacaoUsoImovel
                            .mudouCulturaTemporaria &&
                          _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                            .mudouProdutividade
                            ? "text"
                            : "",
                        attrs: {
                          prop: "produtividade",
                          label: "Produtividade",
                          width: "200",
                          formatter: _vm.formatProdutividade
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.destinacaoUsoImovel.semoventes &&
      _vm.destinacaoUsoImovel.semoventes.length > 0
        ? _c(
            "app-collapse-child",
            {
              class:
                _vm.compararDestinacaoUsoImovel &&
                _vm.compararDestinacaoUsoImovel.mudouSemovente
                  ? "text-collapse"
                  : "",
              attrs: { title: "Semoventes" }
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.destinacaoUsoImovel.semoventes } },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhum semovente cadastrado.")
                  ]),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouSemovente &&
                      _vm.compararDestinacaoUsoImovel.mudouSemovente.mudouTipo
                        ? "text"
                        : "",
                    attrs: {
                      prop: "tipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _vm.destinacaoUsoImovel.semoventes[0].area !== 0 &&
                  _vm.destinacaoUsoImovel.semoventes[0].area !== "" &&
                  _vm.destinacaoUsoImovel.semoventes[0].area !== null
                    ? _c("el-table-column", {
                        class:
                          _vm.compararDestinacaoUsoImovel &&
                          _vm.compararDestinacaoUsoImovel.mudouSemovente &&
                          _vm.compararDestinacaoUsoImovel.mudouSemovente
                            .mudouArea
                            ? "text"
                            : "",
                        attrs: {
                          prop: "area",
                          label: "Área",
                          formatter: _vm.formatAreaHectare
                        }
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouSemovente &&
                      _vm.compararDestinacaoUsoImovel.mudouSemovente
                        .mudouNumeroCabecas
                        ? "text"
                        : "",
                    attrs: { prop: "numeroCabecas", label: "Número de cabeças" }
                  }),
                  _vm.produtividade
                    ? _c("el-table-column", {
                        class:
                          _vm.compararDestinacaoUsoImovel &&
                          _vm.compararDestinacaoUsoImovel.mudouSemovente &&
                          _vm.compararDestinacaoUsoImovel.mudouSemovente
                            .mudouProdutividade
                            ? "text"
                            : "",
                        attrs: {
                          prop: "produtividade",
                          label: "Produtividade (cabeças/hectare)",
                          width: "300"
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.destinacaoUsoImovel.outrasAtividades &&
      _vm.destinacaoUsoImovel.outrasAtividades.length > 0
        ? _c(
            "app-collapse-child",
            {
              class:
                _vm.compararDestinacaoUsoImovel &&
                _vm.compararDestinacaoUsoImovel.mudouOutrasAtividade
                  ? "text-collapse"
                  : "",
              attrs: { title: "Outras atividades", name: "outrasAtividades" }
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.destinacaoUsoImovel.outrasAtividades } },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma outra atividade cadastrada.")
                  ]),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouOutrasAtividade &&
                      _vm.compararDestinacaoUsoImovel.mudouOutrasAtividade
                        .mudouTipo
                        ? "text"
                        : "",
                    attrs: {
                      prop: "tipo",
                      label: "Tipo",
                      formatter: _vm.getAtividadesOutros
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouOutrasAtividade &&
                      _vm.compararDestinacaoUsoImovel.mudouOutrasAtividade
                        .mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      prop: "area",
                      label: "Área",
                      formatter: _vm.formatAreaHectare
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouOutrasAtividade &&
                      _vm.compararDestinacaoUsoImovel.mudouOutrasAtividade
                        .mudouObservacoes
                        ? "text"
                        : "",
                    attrs: { prop: "observacoes", label: "Observações" }
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.destinacaoUsoImovel.edificacoes &&
      _vm.destinacaoUsoImovel.edificacoes.length > 0
        ? _c(
            "app-collapse-child",
            {
              class:
                _vm.compararDestinacaoUsoImovel &&
                _vm.compararDestinacaoUsoImovel.mudouEdificacoes
                  ? "text-collapse"
                  : "",
              attrs: { title: "Edificações", name: "edificacoes" }
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.destinacaoUsoImovel.edificacoes } },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma edificação cadastrada.")
                  ]),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouEdificacoes &&
                      _vm.compararDestinacaoUsoImovel.mudouEdificacoes.mudouTipo
                        ? "text"
                        : "",
                    attrs: {
                      prop: "tipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouEdificacoes &&
                      _vm.compararDestinacaoUsoImovel.mudouEdificacoes.mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      prop: "area",
                      label: "Área",
                      formatter: _vm.formatUnidadeArea
                    }
                  }),
                  _vm.destinacaoUsoImovel.edificacoes[0].funcao !== "" &&
                  _vm.destinacaoUsoImovel.edificacoes[0].funcao !== null
                    ? _c("el-table-column", {
                        class:
                          _vm.compararDestinacaoUsoImovel &&
                          _vm.compararDestinacaoUsoImovel.mudouEdificacoes &&
                          _vm.compararDestinacaoUsoImovel.mudouEdificacoes
                            .mudouFuncao
                            ? "text"
                            : "",
                        attrs: { prop: "funcao", label: "Função" }
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ac18ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ac18ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesDestinacaoUsoImovel.vue
// module id = null
// module chunks = 